import icons from 'assets/icons'
import React, { useEffect, useRef, useState } from 'react'
//import {useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import { openSidebar } from 'redux/features/general/generalSlice'
import images from '../../assets/images/images'
//import { CSSTransition } from "react-transition-group";
import { motion, useCycle,AnimatePresence } from 'framer-motion'
import {menu} from 'utils/Constants'
import {userInfo} from 'utils/Auth'

const Sidebar = () => {
	const sidebarRef = useRef()
	const dispatch = useDispatch()
	const { sidebarToggle } = useSelector((state) => state.general)
	const [open] = useCycle(false, true)
	const [sideMenu, setSideMenu] = useState([])
	useEffect(() => {
		if (userInfo) {
			setSideMenu(menu.filter(m => !m.disabled))
		}
		return () => setSideMenu([])
	},[userInfo])
	// const toggleFunction = () => {
	//     // if(sidebarToggle){
	//     //     document.getElementById('sidebar').style.display = 'flex'
	//     // }
	//     dispatch(openSidebar())
	// }

	const itemVariants = {
		closed: {
			opacity: 0,
		},
		open: { opacity: 1 },
	}

	const sideVariants = {
		closed: {
            opacity: 0,
			transition: {
				//staggerChildren: 0.1,
				//staggerDirection: -1,
			},
		},
		open: {
            opacity: 1,
			transition: {
				//staggerChildren: 0.1,
				//staggerDirection: 1, 
			},
		},
	}
	if (!userInfo) {
		return false
	}
	return (
        <AnimatePresence>
		{sidebarToggle && !open && (
			<motion.aside>
				<motion.div
					//className='container'
                    transition={{
                        delay: 5.5,
                        x: { duration: 5 },
                        default: { ease: "linear" }
                      }}
					initial='closed'
					animate='open'
					variants={sideVariants}
					ref={sidebarRef}
					className={sidebarToggle ? 'sidebar active' : 'sidebar'}
					id='sidebar'
				>
					<div  className='sidebar-logo'>
						<Link to='/projects' className='d-flex align-items-center'>
						<div className='sidebar-logo-container'>
							<img src={images.logo} alt='' />
						</div>
						</Link>
						<icons.menu onClick={() => dispatch(openSidebar())} className='sidebar-logo-icon' size={25} />
					</div>
					<div className='sidebar-menu'>
						{sideMenu?.map((mn, i) => (
							<NavLink className='sidebar-menu-item' to={mn.path} key={i}>
								<motion.a  variants={itemVariants} className='sidebar-menu-item-icon'>
									{mn.icon}
								</motion.a>
								<motion.a  variants={itemVariants} className='sidebar-menu-item-text'>
									{mn.name}
								</motion.a>
							</NavLink>
						))}
					</div>
					<div className='sidebar-footer'>
						<div className='text-bold heading-6'>Nuevo Project Portal</div>
						<div className='text-sm mb-2'>© 2023 All Rights Reserved</div>
						<div className='text-sm'>Made with ❤️ by Nuevo 07 Team</div>
					</div>
				</motion.div>
			</motion.aside>
		)}
        </AnimatePresence>
	)
}

export default Sidebar
